import { InjectionToken } from '@angular/core';
import { RuntimeConfig } from '../models/runtime-config.interface';

export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>(
  'Runtime Config',
);
